import momenttime, { MOMENT_TIME } from '../momenttime'

// 设置一些key的常量
const COLLATE_YEAR_REPORT_KEY = 'h5_fate_year_report_status';
const COLLATE_DONATE_POP_KEY = 'h5_fate_donate_pop_status';
/**
 * 操作localstorage的一些公共方法
 */
var LS = {
    /**
     * 查看年度报告点击状态
     */
    checkCollateYearReportStatus() {
        var curStatus = localStorage.getItem(COLLATE_YEAR_REPORT_KEY);
        if(!curStatus) {
            localStorage.setItem(COLLATE_YEAR_REPORT_KEY, false);
            return false;
        }else {
            return JSON.parse(curStatus);
        }
    },
    /**
     * 设置年度报告点击状态
     * @param {布尔值} value 
     */
    setCollateYearReportStatus(value) {
        localStorage.setItem(COLLATE_YEAR_REPORT_KEY, value);
    },
    /**
     * 查看友情捐赠弹框状态
     */
    checkCollateDonatePopStatus() {
        var curStatus = localStorage.getItem(COLLATE_DONATE_POP_KEY);
        if(!curStatus) {
            localStorage.setItem(COLLATE_DONATE_POP_KEY, false);
            return false;
        }else {
            return JSON.parse(curStatus);
        }
    },
    /**
     * 设置友情捐赠弹框状态
     * @param {布尔值} value 
     */
    setCollateDonatePopStatus(value) {
        localStorage.setItem(COLLATE_DONATE_POP_KEY, value);
    },

}

export {
    LS
}